import { useEffect } from 'react';

import { useFetcher } from '@remix-run/react';

import type { Recommendation, SlotRecommendation } from '~/interfaces/recommendation';

export interface RecommendationData {
  isLoading: boolean;
  recommendations: Recommendation[];
  boostedRecommendations: Recommendation[];
  slotsEnabled?: boolean;
  slots?: SlotRecommendation[];
}

const useRecommendations = () => {
  const fetcher = useFetcher();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    fetcher.load('/recommendations_data?index');
  }, []);

  return (fetcher?.data || {
    recommendations: [],
    boostedRecommendations: [],
    isLoading: true,
  }) as RecommendationData;
};

export default useRecommendations;
